import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, ClickAwayListener, Tooltip } from '@mui/material';

const StyledTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    fontSize: 16,
  },
});

export default function ClickTooltip({ open, onOpen, onClose, children, title, dataTestId, placement = 'top', wrapperStyle, classes: extClasses }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (onOpen) onOpen();
    else setIsOpen(true);
  };

  const handleClose = () => {
    if (onClose) onClose();
    else setIsOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <StyledTooltip open={open === undefined ? isOpen : open} title={title} classes={extClasses} placement={placement} arrow>
        <Box style={wrapperStyle} onMouseEnter={handleOpen} onMouseLeave={handleClose} onClick={handleOpen} data-testid={dataTestId}>
          {children}
        </Box>
      </StyledTooltip>
    </ClickAwayListener>
  );
}
